export const FETCH_MAILER_ID = 'pages/mailing/FETCH_MAILER_ID';
